import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';

//import { ActiveContactComponent } from './active-contact.component';
import {ContactDisplayComponent} from './contact-display/contact.display.component';
import {AuthGuard} from '../../core/_guards/auth.guard';
import {AppDefaultLayoutComponent} from 'src/app/layout/app-default-layout/app-default-layout.component';

const routes: Routes = [
    {
        path: '',
        component: AppDefaultLayoutComponent,
        canActivateChild: [AuthGuard],
        children: [
            {
                path: 'active-contact',
                component: ContactDisplayComponent,
                canActivate: [AuthGuard],
            },
            {
                path: 'home',
                component: ContactDisplayComponent,
                canActivate: [AuthGuard],
            },
        ],
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class ActiveContactRoutingModule {}
